<template>
  <div class="gantt-container">
     <div style="width:100%;height:95%;">
      <el-row style="margin-top: -20px;" >
        <el-col :span="14">
            <el-button type="primary" @click="exportToPNG()">导出PNG</el-button>
            <!-- <el-button type="primary" @click="exportToPDF()">导出PDF</el-button> -->
            <el-button type="primary" @click="exportToExcel()">导出Excel</el-button>
        </el-col>
      </el-row>
        <el-row style="height:95%;margin-top: 20px;margin-left: 10px;">
            <el-col :span="20">
                <gantt ref="timegantt" :tasks="tasks" style="width:100%;height:100%;" @nodeClick="showTaskDetail"></gantt>
            </el-col>
        </el-row>
     </div>
     <el-dialog
      title="任务详情"
      :fullscreen="true"
      append-to-body
      :visible.sync="isShowTaskDetail"
      >
      <div style="margin-top:-20px">
        <TaskDetail
          class="popDetailTaskClass"
          ref="taskDetailRef" 
          :taskInfo="taskInfo"
          :isRead="true"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Gantt from '@/components/Gantt';
import { isEmpty } from 'lodash';
import { getPlanTimeGantt, getProcessTaskDetail } from '@/data-model';
export default {
    name: 'app',
    components: {
        Gantt
    },
    data () {
        return {
            tasks: {
                data: [],
                links: []
            },
            isShowTaskDetail: false,
            taskInfo: {},
            currentProcessInstanceId: '',
            planloading: false,
            currentTimeGanttType: '' // 1计划、2实际、3对比
        };
    },
    created () {
        // this.initPage();
    },
    methods: {
        async initPage (processInstanceId) {
            if (processInstanceId) {
                this.currentProcessInstanceId = processInstanceId;
            } else if (this.$route.params.processInstanceId) {
                this.currentProcessInstanceId = this.$route.params.processInstanceId;
            }
            // console.log(this.currentProcessInstanceId);
            this.tasks.data = {};
            this.viewByPlanTime();
        },
        async viewByPlanTime () {
            // console.log('========计划时间============');
            this.planloading = true;
            let timeGanttInfo = await getPlanTimeGantt(this.currentProcessInstanceId);
            if (timeGanttInfo != null) {
                this.tasks.data = timeGanttInfo.planTime;
            }
            this.planloading = false;
            // console.log(this.tasks);
            setTimeout(() => { // 调用子组件的方法
                this.$refs.timegantt.initData();
            }, 0);
            this.currentTimeGanttType = '1';

            if (timeGanttInfo.unConfigTime) {
                this.$message({
                    message: '温馨提示：该流程的计划时间没有配置完成，请联系相关人员配置。',
                    type: 'warning',
                    duration: 3000
                });
                return false;
            }
            setTimeout(() => { // 调用子组件的方法
                this.$refs.timegantt.initData();
            }, 0);
        },
        async showTaskDetail (id) {
            let clickNode = null;
            for (var i = 0; i < this.tasks.data.length; i++) {
                let node = this.tasks.data[i];
                if (id === node.id) {
                    clickNode = node;
                    break;
                }
            }
            if (clickNode) {
                if (isEmpty(clickNode.taskInstanceId)) {
                    this.$message({
                        message: '当前任务还未开始',
                        type: 'warning',
                        duration: 3000
                    });
                    return;
                }
                this.isShowTaskDetail = false;
                this.taskInfo = await getProcessTaskDetail(clickNode.taskInstanceId);
                this.isShowTaskDetail = true;
                setTimeout(() => {
                    this.$refs.taskDetailRef._initFormData();
                }, 0);
            } else {
                this.$message({
                    message: '当前任务配置有问题，请联系管理员查看',
                    type: 'danger',
                    duration: 3000
                });
            }
        },
        exportToPDF () {
            this.$refs.timegantt.exportToPDF();
        },
        exportToExcel () {
            this.$refs.timegantt.exportToExcel();
        },
        exportToPNG () {
            this.$refs.timegantt.exportToPNG();
        }
    }
};
</script>
<style lang="less" scope>
    .gantt-container {
        flex: 1;
        height: 100%;
        width: 100%;
    }
    .popDetailTaskClass{
      .el-dialog__body{
          padding: 0px 5px;
          color: #606266;
          font-size: 14px;
          word-break: break-all;
       }
    }
</style>


// WEBPACK FOOTER //
// src/pages/process/TimeConfig/TimeConfigGantt/TimeConfigGantt.vue